var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "main", class: { visible: _vm.ready } }, [
    _vm.ready
      ? _c(
          "div",
          { staticClass: "content" },
          [
            _c("IconMapMarkerOrange", { staticClass: "icon" }),
            _vm._v(" "),
            _c("label", { staticClass: "static" }, [
              _vm._v("Your Local Office"),
            ]),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "name", attrs: { href: _vm.clinic.clinicUrl } },
              [_vm._v(_vm._s(_vm.clinic.name))]
            ),
            _vm._v(" "),
            _c("label", { staticClass: "address" }, [
              _vm._v(_vm._s(_vm.clinic.address)),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "address" }, [
              _vm._v(
                _vm._s(_vm.clinic.city) +
                  ", " +
                  _vm._s(_vm.clinic.state) +
                  " " +
                  _vm._s(_vm.clinic.zipCode)
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "phone",
                attrs: {
                  href: "tel:" + this.helpers().callCenterPhoneNumber(),
                  target: "_top",
                },
              },
              [_vm._v(_vm._s(this.helpers().callCenterPhoneNumber()))]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }